import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
export function getProducts() {
  return api
    .get(UtilsUrl.productionURL() + "/products")
    .then((res) => res.data);
}

export function getProductCategories() {
  return api
    .get(UtilsUrl.productionURL() + "/products/categories")
    .then((res) => res.data);
}

export async function addProduct(productData) {
  const form = new FormData();
  form.append("image", productData.image);

  const { data } = await api.post(
    UtilsUrl.productionURL() + "/products/upload-image",
    form
  );

  const product = {
    name: productData.name,
    productCode: productData.productCode,
    categoryId: productData.category.id,
    defaultUnitOfMeasureId: productData.defaultUnitOfMeasure.id,
    imagePath: data,
  };

  console.log(product);

  return api
    .post(UtilsUrl.productionURL() + "/products", product)
    .then((res) => res.data);
}
export function getAllProducts() {
  return api.get(UtilsUrl.productionURL() + "/products");
  // .then((res) => res.data);
}

export function getProductById({ queryKey }) {
  const [_, id] = queryKey;
  if (id)
    return api
      .get(UtilsUrl.productionURL() + `/products/${id}`)
      .then((res) => res.data);
}
